/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Router configuration for TariffsAndServices
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.4.0
 */

import { EBasketType } from '../../modules/app/appConstants';
import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
import { EProductsPageFrom } from '../../pages/PageProducts/tariffsAndServicesConstants';
import { IProductsRouteConfiguration } from './productsConfiguration';
import { RoutePath } from './routesConstants';

export const ProductOfferingsRouteConfiguration: IProductsRouteConfiguration[] = [
    {
        basketType: EBasketType.HEADER,
        breadCrumbs: [EBreadCrumbType.products, EBreadCrumbType.productOfferings],
        pageFrom: EProductsPageFrom.HEADER,
        path: RoutePath.wizardProductOfferings,
    },
    {
        basketType: EBasketType.CAMPAIGN_PARTICIPANTS,
        breadCrumbs: [EBreadCrumbType.campaigns, EBreadCrumbType.productOfferings],
        pageFrom: EProductsPageFrom.CAMPAIGNS,
        path: RoutePath.wizardProductOfferingsFromCampaigns,
    },
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.productsFromSubscribers,
            EBreadCrumbType.productOfferings,
        ],
        pageFrom: EProductsPageFrom.SUBSCRIBERS,
        path: RoutePath.wizardProductOfferingsFromSubscribers,
    },
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.subscriberMobileInfo,
            EBreadCrumbType.productsFromSubscriberId,
            EBreadCrumbType.productOfferings,
        ],
        pageFrom: EProductsPageFrom.SUBSCRIBER_ID,
        path: RoutePath.wizardProductOfferingsFromSubscriberId,
    },
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.subscriberMobileInfo,
            EBreadCrumbType.productOfferings,
        ],
        pageFrom: EProductsPageFrom.SUBSCRIBER_ID_CHANGE_MEGA_POWERS,
        path: RoutePath.wizardProductOfferingsFromSubscriberIdOnlyMegaPowers,
    },
];
